<template>
  <div>
    <v-card class="main-card">
      <!-- タイトル -->
      <v-card-title class="screen-title">
        <span>サイト一覧(Type4)</span>
        <manual-button path="/type4-internet-site-list/" />
      </v-card-title>

      <!-- サイト一覧(Type4) -->
      <v-card-text class="pa-2 mt-3" v-if="isLoaded">
        <div class="d-flex flex-row justify-end mb-2">
          <v-btn color="primary" @click="load">一覧更新</v-btn>
        </div>
        <app-table
          v-model:table-sort-by="applianceObjectTable.sortBy"
          primary-key="type4Id"
          :fields="applianceObjectTable.fields"
          :items="applianceObjectTable.items"
          :hover="true"
          :per-page="-1"
          @click:row="setSelectedItem"
          :tr-class="rowHighlight"
        >
          <!-- Type -->
          <template #cell(internetType)>
            {{ "Type4" }}
          </template>
        </app-table>
      </v-card-text>
    </v-card>

    <v-card class="main-card mt-3" v-if="isLoadedTabArea">
      <!-- 表タイトル部分 -->
      <v-card-title class="screen-title ml-3 mt-3">
        <v-row class="ga-3">
          <span> インターネットType4 </span>
          <span> {{ selectedItem!.type4Id }} </span>
          <span> {{ selectedItem!.type4Name }} </span>
          <span>
            {{
              $filter.applianceTypeTo(
                selectedItem!.applianceType,
                selectedItem!.bandwidth
              )
            }}
          </span>
        </v-row>
      </v-card-title>
      <v-card-text class="pa-2 mt-3">
        <v-tabs v-model="tabValue" grow hide-slider>
          <v-tab text="インターネットサイト" value="internet"></v-tab>
          <v-tab text="エクストラサイト" value="extra"></v-tab>
        </v-tabs>
        <v-tabs-window v-model="tabValue" style="min-height: 60vh">
          <!-- インターネットサイトタブ-->
          <v-tabs-window-item value="internet">
            <!-- アドレス-->
            <v-row>
              <v-col></v-col>
              <div class="d-flex flex-row ga-1 flex-wrap">
                <v-btn
                  color="primary"
                  @click="showInternetSiteEdit"
                  v-permission.config
                  >サイト編集</v-btn
                >
              </div>
            </v-row>
            <!-- アドレステーブル-->
            <v-row no-gutters>
              <span class="font-weight-bold my-2"> アドレス </span>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <app-search
                  :search="addressList.search"
                  v-model="addressList.filter"
                />
              </v-col>
            </v-row>
            <div class="d-flex flex-row justify-end mb-2">
              <v-btn color="primary" @click="reloadInternet">一覧更新</v-btn>
            </div>
            <app-table
              v-model:table-sort-by="addressList.sortBy"
              :sort-null-last="true"
              :sort-compare="customSortAddress"
              :sort-compare-key="['ipAddressName']"
              :fields="addressList.fields"
              :items="addressList.items"
              :filter="addressList.filter"
              :filter-option="addressList.filter_option"
              primary-key="ipAddressId"
              sticky-header="50vh"
              :tr-class="() => undefined"
            >
              <template #cell(ipAddressName)="{ value }">
                {{ $filter.emptyTo(value, "-") }}
              </template>
              <template #cell(isPolicyInUse)="data">
                {{ $filter.enumTo(data.value, "isPolicyInUse") }}
              </template>
            </app-table>

            <!-- FQDN-->
            <v-row no-gutters>
              <span class="font-weight-bold mb-2 mt-4"> FQDN </span>
            </v-row>
            <v-row no-gutters>
              <v-col>
                <app-search
                  :search="fqdnList.search"
                  v-model="fqdnList.filter"
                />
              </v-col>
            </v-row>
            <div class="d-flex flex-row justify-end mb-2">
              <v-btn color="primary" @click="reloadInternet">一覧更新</v-btn>
            </div>
            <!-- FQDNテーブル-->
            <app-table
              v-model:table-sort-by="fqdnList.sortBy"
              :sort-null-last="true"
              :sort-compare="customSortFqdn"
              :sort-compare-key="['fqdnName']"
              :fields="fqdnList.fields"
              :items="fqdnList.items"
              :filter="fqdnList.filter"
              :filter-option="fqdnList.filter_option"
              primary-key="fqdnId"
              sticky-header="50vh"
              :tr-class="() => undefined"
            >
              <template #cell(fqdnName)="{ value }">
                {{ $filter.emptyTo(value, "-") }}
              </template>
              <template #cell(isPolicyInUse)="data">
                {{ $filter.enumTo(data.value, "isPolicyInUse") }}
              </template>
            </app-table>
          </v-tabs-window-item>

          <!-- エクストラサイトタブ-->
          <v-tabs-window-item value="extra">
            <!-- エクストラ-->
            <v-row no-gutters class="mt-2">
              <v-col>
                <app-search :search="extra.search" v-model="extra.filter" />
              </v-col>
              <div class="d-flex flex-row ga-1 flex-wrap ml-2">
                <v-btn color="primary" @click="toAddSite" v-permission.config
                  >追加</v-btn
                >
              </div>
            </v-row>
            <!-- エクストラサイトテーブル-->
            <div class="d-flex flex-row justify-end mb-2">
              <v-btn color="primary" @click="reloadExtranet">一覧更新</v-btn>
            </div>
            <app-table
              v-model:table-sort-by="extra.sortBy"
              :sort-null-last="true"
              :fields="extra.fields"
              :items="extraSite.siteList"
              :hover="true"
              :filter="extra.filter"
              :filter-option="extra.filter_option"
              primary-key="siteId"
              @click:row="extraSelected"
              sticky-header="50vh"
            >
              <template #cell(ipAddressName)="{ value }">
                <template v-if="value.length !== 0">
                  <div v-for="(item, index) in value" :key="index">
                    {{ $filter.emptyTo(item, "-") }}
                  </div>
                </template>
                <template v-else>{{ "-" }}</template>
              </template>
              <template #cell(ipAddress)="{ value }">
                <template v-if="value.length !== 0">
                  <div v-for="(item, index) in value" :key="index">
                    {{ item }}
                  </div>
                </template>
                <template v-else>{{ "-" }}</template>
              </template>
              <template #cell(isPolicyInUse)="{ value }">
                <template v-if="value.length !== 0">
                  <div v-for="(item, index) in value" :key="index">
                    {{ $filter.enumTo(item, "isPolicyInUse") }}
                  </div>
                </template>
                <template v-else>{{ "-" }}</template>
              </template>
            </app-table>
          </v-tabs-window-item>
        </v-tabs-window>
      </v-card-text>
    </v-card>
  </div>
</template>

<script lang="ts">
import type { ApplianceInfo } from "@/apis/ContractApi";
import type {
  Type4ExtraList,
  Type4ExtraSite,
  Type4ExtraSiteList,
  Type4InternetAddress,
  Type4InternetFQDN,
  Type4InternetSite,
} from "@/apis/Type4SiteApi";
import { defineComponent } from "vue";
import enumTo from "@/filters/enum-to.filter";
import type { SortCompareFunc } from "@/services/SortService";
import Type4InternetSiteReference from "@/modals/type4/Type4InternetSiteReference.vue";
import internetStatusTo from "@/filters/internet-status-to.filter";
import applianceTypeTo from "@/filters/appliance-type-to.filter";
import Type4ExtraSiteReference from "@/modals/type4/Type4ExtraSiteReference.vue";
import type {
  AppTableHeader,
  FilterOption,
  SortItem,
} from "@/components/AppTable.vue";
import Type4ExtraSiteEdit from "@/modals/type4/Type4ExtraSiteEdit.vue";
import type { SearchOption } from "@/components/AppSearch.vue";

export default defineComponent({
  name: "Type4SiteList",
  data() {
    return {
      tabValue: "internet",
      isLoaded: false,
      isLoadedTabArea: false,
      selectedItem: null as null | ApplianceInfo,
      applianceObjectTable: {
        sortBy: {
          key: "lineNumber",
          order: "asc",
        } as SortItem,
        fields: applianceObjectListFields,
        items: [] as ApplianceInfo[],
      },

      internetSite: {} as Type4InternetSite,
      extraSite: {} as Type4ExtraSite,
      /** インターネットアドレス */
      addressList: {
        sortBy: {
          key: "ipAddressName",
          order: "asc",
        } as SortItem,
        fields: FIELDS.address,
        items: [] as Type4InternetAddress[],
        selected: [],
        search: {
          ipAddressName: {
            type: "text",
            label: "アドレス名",
          },
          ipAddress: {
            type: "text",
            label: "アドレス",
          },
        } as SearchOption,
        filter: {} as Record<string, unknown>,
        filter_option: {
          ipAddressName: "like",
          ipAddress: "like",
        } as FilterOption,
      },
      /** インターネットFQDN */
      fqdnList: {
        sortBy: {
          key: "fqdnName",
          order: "asc",
        } as SortItem,
        fields: FIELDS.fqdn,
        items: [] as Type4InternetFQDN[],
        selected: [],
        search: {
          fqdnName: {
            type: "text",
            label: "FQDN名",
          },
          fqdn: {
            type: "text",
            label: "FQDN",
          },
        } as SearchOption,
        filter: {} as Record<string, unknown>,
        filter_option: {
          fqdnName: "like",
          fqdn: "like",
        } as FilterOption,
      },
      /** エクストラサイト */
      extra: {
        sortBy: {
          key: "siteName",
          order: "asc",
        } as SortItem,
        fields: FIELDS.extra,
        selected: [],
        search: {
          siteName: {
            type: "text",
            label: "サイト名",
          },
          ipAddressName: {
            type: "text",
            label: "アドレス名",
          },
          ipAddress: {
            type: "text",
            label: "アドレス",
          },
        } as SearchOption,
        filter: {} as Record<string, unknown>,
        filter_option: {
          siteName: "like",
          ipAddressName: "like",
          ipAddress: "like",
        } as FilterOption,
      },
    };
  },
  async mounted() {
    await this.load();
    this.isLoaded = true;
  },
  computed: {
    /** インターネットアドレスカスタムソート */
    customSortAddress(): SortCompareFunc<Type4InternetAddress> {
      return this.$service.tableSortCompare(
        this.addressList.sortBy,
        ["ipAddressName", { nullLast: true }],
        ["ipAddress", "asc"]
      );
    },
    /** インターネットFqdnカスタムソート */
    customSortFqdn(): SortCompareFunc<Type4InternetFQDN> {
      return this.$service.tableSortCompare(
        this.fqdnList.sortBy,
        ["fqdnName", { nullLast: true }],
        ["fqdn", "asc"]
      );
    },
  },

  methods: {
    /** 初期化機能 */
    async load() {
      // アプライアンス一覧の取得APIを呼び出し、データ取得を行う
      this.applianceObjectTable.items = [];
      const data: ApplianceInfo[] = (await this.$api.contract.getAppliances())
        .applianceInfoList;
      data.forEach((item) => {
        if (item.internetType === "TYPE4") {
          this.applianceObjectTable.items.push(item);
        }
      });
      if (this.selectedItem) {
        let selectedRow = this.applianceObjectTable.items.find(
          (v) => v.type4Id === this.selectedItem?.type4Id
        );

        if (selectedRow) {
          await this.setSelectedItem(selectedRow);
        } else {
          this.isLoadedTabArea = false;
          this.selectedItem = null;
        }
      }
    },
    /** インターネットタブ一覧更新 */
    async reloadInternet() {
      // インターネットサイト情報を取得用APIを呼び出し、データ取得を行う
      await this.getInternetList();
    },
    /** エクストラサイトタブ一覧更新 */
    async reloadExtranet() {
      // エクストラサイト情報を取得用APIを呼び出し、データ取得を行う
      await this.getExtraList();
    },
    /** 選択した行のデータをセットする */
    async setSelectedItem(row: ApplianceInfo) {
      this.selectedItem = row;
      await this.callApis();
    },
    /** 選択した行の背景色を変更する処理 */
    rowHighlight(item: ApplianceInfo): string[] | undefined {
      if (item.type4Id == this.selectedItem?.type4Id) {
        return ["table-success"];
      }
      return ["clickable"];
    },
    /** タブエリアの情報を取得する */
    async callApis(): Promise<void> {
      // 情報の再取得を行う際に一度タブエリアを非表示にする
      if (this.isLoadedTabArea) this.isLoadedTabArea = false;
      // インターネットサイト情報を取得用APIを呼び出し、データ取得を行う
      await this.getInternetList();
      // エクストラサイト情報を取得用APIを呼び出し、データ取得を行う
      await this.getExtraList();

      this.isLoadedTabArea = true;
    },
    /** インターネット一覧のデータ取得を行う*/
    async getInternetList() {
      this.internetSite = await this.$api.type4SiteApi.getType4InternetSite(
        this.selectedItem!.type4Id
      );
      // 取得した配列のソート
      this.addressList.items = this.internetSite.addressList.sort((a, b) => {
        return this.$service.sortCompare(a, b, [
          ["ipAddressName", "asc", { nullLast: true }],
          ["ipAddress", "asc"],
        ]);
      });
      // 取得した配列のソート
      this.fqdnList.items = this.internetSite.fqdnList.sort((a, b) => {
        return this.$service.sortCompare(a, b, [
          ["fqdnName", "asc", { nullLast: true }],
          ["fqdn", "asc"],
        ]);
      });
    },
    /** エクストラ一覧のデータ取得を行う*/
    async getExtraList() {
      this.extraSite = await this.$api.type4SiteApi.getType4ExtraSite(
        this.selectedItem!.type4Id
      );
      /**
       * 取得IPアドレス配列のソート
       */
      this.extraSite.siteList.forEach((e) => {
        e.addressList.sort((a, b) => {
          return this.$service.sortCompare(a, b, [
            ["ipAddressName", "asc", { nullLast: true }],
            ["ipAddress", "asc"],
          ]);
        });
      });
    },
    /** 編集機能 */
    // インターネットサイト編集
    async showInternetSiteEdit() {
      await this.$modal.show(Type4InternetSiteReference, {
        internetSite: this.internetSite,
        type4Id: this.selectedItem!.type4Id,
      });
      await this.callApis();
    },
    /** 追加機能 */
    async toAddSite() {
      await this.$modal.show(Type4ExtraSiteEdit, {
        type4Id: this.selectedItem!.type4Id,
        type4SiteKeyId: this.extraSite.type4SiteKeyId,
      });
      await this.callApis();
    },
    /** 行選択機能 */
    async extraSelected(item: Type4ExtraSiteList) {
      await this.$modal.show(Type4ExtraSiteReference, {
        extraSite: item,
        type4Id: this.selectedItem!.type4Id,
        type4SiteKeyId: this.extraSite.type4SiteKeyId,
      });
      await this.callApis();
    },
  },
});

/** 列のデータ(アプライアンスオブジェクト一覧) */
const applianceObjectListFields = [
  {
    key: "lineNumber",
    title: "回線番号",
    width: "200px",
    sortable: true,
    sortByFormatted: true,
    filterByFormatted: false,
    formatter: (value: null, key: null, item: ApplianceInfo) => {
      return item.wnumberMainAct + " " + item.wnumberMainSby;
    },
  },
  { key: "vpnVnCode", title: "VPN/VNコード", sortable: true },
  { key: "internetType", title: "Type", sortable: true },
  { key: "type4Id", title: "Type4ID", sortable: true },
  { key: "type4Name", title: "Type4名", sortable: true },
  {
    key: "mainSite",
    title: "メインサイト",
    sortable: true,
    sortByFormatted: true,
    filterByFormatted: false,
    formatter: (value: string) => {
      return enumTo(value, "mainSite");
    },
  },
  {
    key: "appliance",
    title: "アプライアンス",
    sortable: true,
    sortByFormatted: true,
    filterByFormatted: false,
    formatter: (value: null, key: null, item: ApplianceInfo) => {
      return applianceTypeTo(item.applianceType, item.bandwidth);
    },
  },
  {
    key: "status",
    title: "状態",
    sortable: true,
    sortByFormatted: true,
    filterByFormatted: false,
    formatter: (value: null, key: null, item: ApplianceInfo) => {
      return internetStatusTo(item.isStart, item.isInternetPause);
    },
  },
] as AppTableHeader<ApplianceInfo>[];
/** テーブルfields*/
const FIELDS = {
  address: [
    {
      key: "ipAddressName",
      title: "アドレス名",
      sortable: true,
    },
    {
      key: "ipAddress",
      title: "アドレス",
      width: "250px",
      sortable: true,
    },
    {
      key: "isPolicyInUse",
      title: "ポリシー使用有無",
      sortable: true,
    },
  ] as AppTableHeader<Type4InternetAddress>[],
  fqdn: [
    {
      key: "fqdnName",
      title: "FQDN名",
      sortable: true,
    },
    {
      key: "fqdn",
      title: "FQDN",
      width: "250px",
      sortable: true,
    },
    {
      key: "isPolicyInUse",
      title: "ポリシー使用有無",
      sortable: true,
    },
  ] as AppTableHeader<Type4InternetFQDN>[],
  extra: [
    {
      key: "siteName",
      title: "サイト名",
      sortable: true,
    },
    {
      key: "ipAddressName",
      title: "アドレス名",
      sortable: false,
      filterByFormatted: true,
      formatter: (value: null, key: null, item: Type4ExtraSiteList) => {
        return item.addressList.map((e) => e.ipAddressName);
      },
    },
    {
      key: "ipAddress",
      title: "アドレス",
      sortable: false,
      filterByFormatted: true,
      formatter: (value: null, key: null, item: Type4ExtraSiteList) => {
        return item.addressList.map((e) => e.ipAddress);
      },
    },
    {
      key: "isPolicyInUse",
      title: "ポリシー使用有無",
      width: "200px",
      sortable: false,
      filterByFormatted: false,
      formatter: (value: null, key: null, item: Type4ExtraSiteList) => {
        return item.addressList.map((e) => e.isPolicyInUse);
      },
    },
  ] as AppTableHeader<Type4ExtraList>[],
};
</script>
